import SailboatOffshore16 from '@carbon/icons-react/es/sailboat--offshore/16';
import { Comment, Tooltip } from 'antd';
import * as DOMPurify from 'dompurify';
import moment from 'moment';
import React from 'react';
import styled from 'styled-components';
import { UserStatus } from 'api/models';
import { UserMessageCommentAvatar } from 'components/organisms/conversations/messages-list/components';
import { Caption01, Text03 } from 'components/styles';
import { useTranslation } from 'hooks/use-translation';
import { tryEmojify } from 'utils/emojify';
import { CustomizableText } from '../customizable-text';
import { HumaniseElapsedTime, humaniseWithTime } from '../humanised-date';

const CommentWrapper = styled(Comment)`
  position: relative;
  background-color: var(--purple-10);
  ${Caption01};
  ${Text03};
  display: flex;
  margin-bottom: var(--spacing-03);
  position: relative;

  &:hover {
    background: var(--coolest-gray-10);
  }

  .ant-comment-inner {
    padding: var(--spacing-03) var(--spacing-05) var(--spacing-03)
      var(--spacing-02);
  }
`;

const StyledContent = styled.p`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-03);
`;

const StyledUserNameWrapper = styled.span`
  font-weight: var(--font-weight-bold);
  display: flex;
  align-items: center;
  span {
    margin-right: var(--spacing-02);
  }
`;

const StyledSailboatOffshore16 = styled(SailboatOffshore16)`
  color: purple;
`;

type TimeoffCoverMessageProps = {
  outOfOfficeMessage: string;
  userName: string;
  createdAt: number;
};

const TimeoffCoverMessage = (props: TimeoffCoverMessageProps) => {
  const { outOfOfficeMessage, userName, createdAt } = props;

  const timeoffTitle = useTranslation(
    'settings.out_of_office.cover.message.title',
  );

  return (
    <CommentWrapper
      author={
        <StyledUserNameWrapper>
          <span>{userName}</span>
          <StyledSailboatOffshore16 />
        </StyledUserNameWrapper>
      }
      avatar={
        <UserMessageCommentAvatar
          userStatus={UserStatus.Active}
          createdAt={createdAt}
          isFromSameUser
          userFullName={userName}
          avatarUrl="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png"
        />
      }
      content={
        <StyledContent>
          {timeoffTitle}
          <CustomizableText>
            <p
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                // eslint-disable-next-line @typescript-eslint/naming-convention
                __html: DOMPurify.sanitize(tryEmojify(outOfOfficeMessage)),
              }}
              data-cy="message.outOfOffice.template"
            />
          </CustomizableText>
        </StyledContent>
      }
      datetime={
        <Tooltip title={humaniseWithTime(moment(createdAt))}>
          <span>
            <HumaniseElapsedTime timestamp={moment(createdAt)} />
          </span>
        </Tooltip>
      }
    />
  );
};

export { TimeoffCoverMessage };
